<template>
  <div v-if="modal.visible" class="modal-backdrop" @click.self="handleBackdropClick">
    <div class="modal-box">
      <h2 class="modal-title">{{ modal.title }}</h2>
      <p class="modal-message">{{ modal.message }}</p>
      <div class="modal-actions">
        <button
            v-if="modal.confirmText"
            class="modal-btn confirm"
            @click="handleConfirm"
        >
          {{ modal.confirmText }}
        </button>
        <button class="modal-btn cancel" @click="handleCancel">{{ modal.cancelText }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useModalStore } from "@/store/modalStore";
import { useModalAnalytics, MODAL_TYPES } from "@/composables/useModalAnalytics";
import { onMounted, onUnmounted, watch } from 'vue';

const modal = useModalStore();
const { trackModalOpen, trackModalClose, trackModalInteraction } = useModalAnalytics();

let modalId = null;

// 모달 가시성 변화 추적
watch(() => modal.visible, (newVisible, oldVisible) => {
  if (newVisible && !oldVisible) {
    // 모달 열림
    modalId = trackModalOpen(MODAL_TYPES.NOTIFICATION, {
      title: modal.title,
      message: modal.message,
      hasConfirm: !!modal.confirmText
    }, {
      triggerSource: 'system'
    });
  } else if (!newVisible && oldVisible && modalId) {
    // 모달 닫힘은 각 액션에서 처리
  }
});

const handleConfirm = () => {
  if (modalId) {
    trackModalInteraction(MODAL_TYPES.NOTIFICATION, 'click', {
      elementType: 'confirm_button',
      elementId: 'modal_confirm'
    });
    trackModalClose(MODAL_TYPES.NOTIFICATION, 'user_action', { success: true });
  }
  modal.visible = false;
  modal.onConfirm?.();
}

const handleCancel = () => {
  if (modalId) {
    trackModalInteraction(MODAL_TYPES.NOTIFICATION, 'click', {
      elementType: 'cancel_button', 
      elementId: 'modal_cancel'
    });
    trackModalClose(MODAL_TYPES.NOTIFICATION, 'user_action', { success: false });
  }
  modal.visible = false;
  modal.onCancel?.();
}

const handleBackdropClick = () => {
  if (modalId) {
    trackModalClose(MODAL_TYPES.NOTIFICATION, 'background_click', { success: false });
  }
  modal.visible = false;
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: white;
  padding: 20px 24px;
  border-radius: 8px;
  width: 300px;
  max-width: 80%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  text-align: center;
}

.modal-title {
  font-size: 18px;
  margin-bottom: 12px;
}

.modal-message {
  font-size: 14px;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.modal-btn {
  padding: 6px 12px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.modal-btn.confirm {
  background-color: #F7BE17;;
  color: #151419;
}

.modal-btn.cancel {
  background-color: #e0e0e0;
  color: #333;
}
</style>
